import { useState } from "react";
import Icon from "./Icon";
import { TRIP_COLORS } from "../utils";

export default function NewTripModal({ onClose, onCreate }) {
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [color, setColor] = useState(TRIP_COLORS[0]);
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const handleCreate = async () => {
    if (!name) return;
    setSaving(true);
    await onCreate({ name, startDate, endDate, color, notes });
    setSaving(false);
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <div className="modal-title">New trip</div>
          <button className="modal-close" onClick={onClose}><Icon name="close" size={14} /></button>
        </div>

        <div className="form-group">
          <label className="form-label">Trip name</label>
          <input
            className="form-input"
            placeholder="e.g. Japan & South Korea"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Start date</label>
            <input className="form-input" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">End date</label>
            <input className="form-input" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Notes</label>
          <textarea
            className="form-input"
            placeholder="Packing list, reminders, ideas..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            style={{ resize: "vertical", fontFamily: "inherit" }}
          />
        </div>

        <div className="form-group">
          <label className="form-label">Color</label>
          <div className="color-picker">
            {TRIP_COLORS.map((c) => (
              <div
                key={c}
                className={`color-swatch ${color === c ? "selected" : ""}`}
                style={{ background: c, color: c }}
                onClick={() => setColor(c)}
              />
            ))}
          </div>
        </div>

        <button className="submit-btn" onClick={handleCreate} disabled={!name || saving}>
          {saving ? "Creating..." : "Create trip"}
        </button>
      </div>
    </div>
  );
}
